import { styled } from '@mui/material/styles';

export const Wrapper = styled('div')`
  display: flex;
  justify-content: center;
`;
export const StyledImg = styled('img')`
  max-width: none;
  width: 100%;
  object-fit: cover;
`;
